import * as Yup from 'yup';
import { textMaxLength } from 'constants/fieldsLimits';
import VALIDATION_MESSAGES from 'constants/validationMessages';

export const mandatoryCommentValidationSchema = Yup.object({
  comment: Yup.string().required().max(textMaxLength, VALIDATION_MESSAGES.STRING_MAX_LENGTH(textMaxLength)),
});
